import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { getuserdetails } from "../../../../store/actions/auth";
import JsSIP from "jssip";

import {
  InteractionRequiredAuthError,
  InteractionStatus,
} from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";

import Header from "./Header";
import AgentsFreeIn from "./AgentsFreeIn";
import AgentsFreeOut from "./AgentsFreeOut";
import AgentsUnavailable from "./AgentsUnavailable";
import AgentsAux from "./AgentsAux";
import QueueStats from "./QueueStats";
import Callers from "./Callers";
import { SIP_HOST, AZURE_SCOPE } from "../../../../config";
import { sipConnectionStatus } from "../../../../store/actions/dashboard";
import useSocket from "../../hooks/socketConnect";

const MainContent = props => {
  const dispatch = useDispatch();
  const { instance, inProgress, accounts } = useMsal();
  const [apiData, setApiData] = useState(null);

  const remoteAudio = window.document.createElement("audio");
  remoteAudio.id = "sip-provider-audio";
  window.document.body.appendChild(remoteAudio);

  const socket = new JsSIP.WebSocketInterface(`wss://${SIP_HOST}:443/ws`);

  const sipUsername = props.user.api_token["sipUsername"];
  const sipPassword = props.user.api_token["sipPassword"];

  const configuration = {
    sockets: [socket],
    uri: `sip:${sipUsername}@${SIP_HOST}`,
    password: sipPassword,
  };

  const ua = new JsSIP.UA(configuration);

  const eventHandlers = {
    failed: e => {
      console.log(e);
      // props.sipConnectionStatus({
      //   snooping: false,
      // });
    },
    // ended: () => {
    //   props.sipConnectionStatus({
    //     snooping: false,
    //   });
    // },
  };

  // const options = {
  //   eventHandlers,
  //   mediaConstraints: { audio: true, video: false },
  // };

  ua.on("registered", () => {
    props.sipConnectionStatus({
      registered: true,
    });
  });

  ua.on("registrationFailed", () => {
    props.sipConnectionStatus({
      registered: false,
    });
  });

  ua.on("newRTCSession", ({ originator, session, request }) => {
    // request.setHeader("Test", "Lorem Ipsum");

    // if (originator === "local") {
    //   console.log(request.to.toString());
    // }

    // session.on("connecting", () => {
    //   console.log("Connecting...");
    // });

    // session.on("sending", ({ request }) => {
    //   console.log(`Sending... ${request}`);
    // });

    // session.on("progress", () => {
    //   console.log("Progress...");
    // });

    // session.on("failed", ({ originator, message, cause }) => {
    //   // console.log(`Failed... ${cause}, ${message}`);
    //   props.sipConnectionStatus({
    //     snooping: false,
    //   });
    // });

    // session.on("ended", ({ originator, message, cause }) => {
    //   // console.log(`Ended... ${cause}`);
    //   props.sipConnectionStatus({
    //     snooping: false,
    //   });
    // });

    session.on("accepted", () => {
      try {
        remoteAudio.srcObject = session.connection.getRemoteStreams()[0];
        remoteAudio.play();
        // props.sipConnectionStatus({
        //   snooping: true,
        // });
      } catch (e) {
        console.log(e);
      }
    });
  });

  const startCall = (dest, headerContent) => {
    // ua.terminateSessions();
    // ua.call(dest, options);
    ua.call(dest, {
      eventHandlers,
      mediaConstraints: { audio: true, video: false },
      extraHeaders: [`X-Snoop-Target: ${headerContent}`],
    });
  };

  const stopCall = () => {
    ua.terminateSessions();
  };

  useEffect(() => {
    try {
      ua.start();
    } catch (err) {
      console.log(err);
    }

    const accessTokenRequest = {
      // scopes: ["user.read"],
      scopes: [AZURE_SCOPE],
      account: accounts[0],
    };
    if (!apiData && inProgress === InteractionStatus.None) {
      instance
        .acquireTokenSilent(accessTokenRequest)
        .then(accessTokenResponse => {
          // Acquire token silent success
          let accessToken = accessTokenResponse.accessToken;
          // console.log(accessToken);
          sessionStorage.setItem("azureToken", accessToken);
          dispatch(getuserdetails());
          setApiData(accessToken);
          // Call your API with token
          // callApi(accessToken).then(response => {
          //   console.log(response);
          //   setApiData(response);
          // });
        })
        .catch(error => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
        });
    }

    return () => {
      try {
        ua.stop();
      } catch (e) {
        console.log(e);
      }
    };
  });

  useSocket(props.user, dispatch);

  const activeTab = () => {
    switch (props.header.active_tab) {
      case "agents_available_in":
        return <AgentsFreeIn />;
      case "agents_available_out":
        return <AgentsFreeOut startCall={startCall} stopCall={stopCall} />;
      case "agents_unavailable":
        return <AgentsUnavailable />;
      case "agents_aux":
        return <AgentsAux />;
      case "callers":
        return <Callers startCall={startCall} stopCall={stopCall} />;
      case "q_stats":
        return <QueueStats />;
      default:
        return <AgentsFreeIn />;
    }
  };
  return (
    <div className="border rounded p-1">
      <Header />
      {activeTab()}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    header: state.dashboardReducer.maincontent_header,
    user: state.authReducer.user,
  };
};

export default connect(mapStateToProps, { sipConnectionStatus })(MainContent);
